import { Box, Container, useColorModeValue } from "@chakra-ui/react";

interface SectionWrapperProps {
  id?: string;
  children: React.ReactNode;
  alt?: boolean;
  py?: any;
  contentMaxW?: any;
}

export const SectionWrapper = ({
  id,
  children,
  alt,
  py,
  contentMaxW,
}: SectionWrapperProps) => {
  const bg = useColorModeValue(
    alt ? "gray.50" : "white",
    alt ? "dark.100" : "dark.50",
  );
  const borderColor = useColorModeValue("gray.100", "gray.700");

  return (
    <Box
      id={id}
      bg={bg}
      borderBottom="1px solid"
      borderColor={borderColor}
      py={py ?? { base: 12, md: 20 }}
      scrollMarginTop={{ base: "110px", md: "140px" }}
    >
      {contentMaxW ? <Container maxW={contentMaxW}>{children}</Container> : children}
    </Box>
  );
};
